import { Component } from '@angular/core';

@Component({
    selector: 'yard-terminal-admin',
    templateUrl: './terminal-admin.component.html',
    styleUrls: ['./terminal-admin.component.scss'],
    standalone: false
})
export class TerminalAdminComponent {

}
